import FormattedMessage from 'I18n/components/FormattedMessage';
import CurrentPlanButton from 'pricing-pages-lib/buttons/CurrentPlanButton';
import { getButtonVariantProps, getTrellisButtonVariantProps } from 'pricing-pages-lib/utils/buttonVariantUtils';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { SUITE_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';
import { MerchCardWrapper } from './MerchCardSharedComponents';
import SuiteBusinessObjectives from './business-objectives/SuiteBusinessObjectives';
import HighlightedFreePriceDisplay from './price-display/HighlightedFreePriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuiteFreeTile = ({
  isFreeToStarter,
  gridItemProps
}) => {
  const isAppReady = useGlobalLoading();
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel: 'FREE'
  }));
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });
  const trellisCtaVariantProps = getTrellisButtonVariantProps({
    variant: 'block'
  });

  // In order for the grid to work, the wrapper element requires display: contents.
  // Children of the display grid item must get the grid-start attributes directly
  return /*#__PURE__*/_jsxs(MerchCardWrapper, {
    children: [/*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "800",
      position: "relative",
      gridRowStart: 1,
      children: /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.suiteTile.freeCard.title"
        })
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "600",
      gridRowStart: 2,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "merchCards.suiteTile.freeCard.description"
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 3,
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !isAppReady,
        heights: [20, 33, 20],
        widths: [60, 80, 140],
        children: /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {})
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 5,
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !isAppReady,
        heights: [47],
        widths: ['100%'],
        children: isFreeToStarter && isCurrentPlanLevel ? /*#__PURE__*/_jsx(CurrentPlanButton, {
          visible: trellisCtaVariantProps.visible
        }) : /*#__PURE__*/_jsx(SignupButton, Object.assign({
          sourceId: "pricing-hero",
          productLine: "crm",
          use: "primary",
          trackingSource: SUITE_CARD
        }, ctaVariantProps))
      })
    })), /*#__PURE__*/_jsx(PPUIGrid, Object.assign({}, gridItemProps, {
      gridTemplateRows: "subgrid",
      gridRowStart: 6,
      gridRowEnd: 8,
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !isAppReady,
        heights: [47],
        widths: ['100%'],
        children: /*#__PURE__*/_jsx(SuiteBusinessObjectives, {
          productLevel: FREE
        })
      })
    }))]
  });
};
export default SuiteFreeTile;